import { Injectable, signal } from "@angular/core";
import { ApplicationOverlayConfig } from "@interfaces/interfaces";

@Injectable({
  providedIn: "root",
})
export class ApplicationOverlayService {
  showOverlay = signal(false);
  overlayConfig = signal<ApplicationOverlayConfig>(null);

  setOverlayConfig(config: ApplicationOverlayConfig) {
    this.overlayConfig.set(config);
    this.showOverlay.set(true);
  }

  hideOverlay() {
    if (this.overlayConfig().canBeClosed === false) {
      return;
    }
    this.showOverlay.set(false);
    this.overlayConfig.set(null);
  }
}
